<template>
    <b-navbar id="navigator" toggleable="lg" type="dark" class="py-3">
        <b-navbar-brand href="#">
            <div v-if="unclickable">
                <img style="height:30px;"
                     src="@/assets/images/kalamaio-logo-full-light-72.png"
                     alt="Kalamaio Logo"/>
            </div>
            <div v-else>
                <router-link :to="{path:'/'}">
                    <img style="height:30px;"
                         src="@/assets/images/kalamaio-logo-full-light-72.png"
                         alt="Kalamaio Logo"/>
                </router-link>
            </div>
        </b-navbar-brand>

        <b-navbar-toggle v-if="!unclickable" target="nav-collapse">
        </b-navbar-toggle>

        <b-collapse v-if="$store.state.userProfile.role === 'VIP'" id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-item v-if="!unclickable" href="#">Manage VIP Page</b-nav-item>
                <b-nav-item v-if="!unclickable" @click="about">About</b-nav-item>
                <b-nav-item v-if="!unclickable" @click="logout">Logout</b-nav-item>
            </b-navbar-nav>
        </b-collapse>

        <b-collapse v-if="$store.state.userProfile.role === 'FAN'" id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-item v-if="!unclickable" @click="about">About</b-nav-item>
                <b-nav-item v-if="!unclickable" @click="logout">Logout</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import firebase from '../firebase';

export default {
    name: 'Navigator',
    props: [
        'unclickable'
    ],
    methods: {
        logout() {
            firebase.auth.signOut().then(() => {
                this.$store.dispatch('clearData');
                this.$router.push('/login');
            }).catch((err) => {
                console.log(err);
            });
        },
        about() {
            this.$router.push({ name: 'About' });
        }
    }
};
</script>
